import React from "react";

function Profile() {
  return (
    <div className="container mx-auto flex flex-col bg-white p-10 rounded-xl lg:w-1/3">
      <div className="flex items-center">
        <img
          alt="User profile"
          src="/uaaaou2.png"
          className="rounded-full w-28 h-28 box-content border border-gray-200"
        />
        <h2 className="text-xl font-bold ml-4">UAAAOU</h2>
      </div>

      <div className="pt-4 font-normal">
        <p>
          お仕事のご依頼やその他のご相談は以下のメールアドレスからお願いします。
          <br />
          ご依頼を検討中の方は、ぜひ資料をダウンロードしてみてください。
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 my-4">
        <a
          href="https://twitter.com/uaaaou"
          class=" hover:bg-gray-200 py-2 focus:ring-4 border border-gray-200  rounded-lg text-center font-semibold"
          target="_blank"
        >
          X(Twitter)
        </a>
        <a
          href="https://www.pixiv.net/users/3440126"
          class=" hover:bg-gray-200 py-2 focus:ring-4 border border-gray-200  rounded-lg text-center font-semibold"
          target="_blank"
        >
          pixiv
        </a>
        <a
          href="mailto:uaaaou.gmemory0101@gmail.com"
          class=" hover:bg-gray-200 py-2 focus:ring-4 border border-gray-200  rounded-lg text-center font-semibold"
          target="_blank"
        >
          メール
        </a>
      </div>
    </div>
  );
}

export default Profile;
